<template>
  <div id="app"><router-view></router-view></div>
</template>

<script>
import { setWxUserInfo } from '@/utils';
export default {
    name: 'App',
    mounted () {
        this.prepareToBack();
        setWxUserInfo();
    },
    methods: {
        prepareToBack () {
            // document.hidden是一个布尔值，简单的表示标签页显示或者隐藏
            const hiddenProperty = 'hidden' in document ? 'hidden'
                : 'webkitHidden' in document ? 'webkitHidden'
                    : 'mozHidden' in document ? 'mozHidden'
                        : null;
            const visibilityChangeEvent = hiddenProperty.replace(/hidden/i, 'visibilitychange');
            const onVisibilityChange = () => {
                if (document[hiddenProperty]) { // 页面隐藏
                    console.log('app页面隐藏');
                    window.webBuriedFn && window.webBuriedFn('pageDuration', '页面停留时长');
                } else { // 页面展示
                    console.log('app页面展示');
                    window.webBuriedFn && window.webBuriedFn('pageView', '页面浏览');
                }
            };
            // 监听标签页显示隐藏（visibilitychange事件）
            document.addEventListener(visibilityChangeEvent, onVisibilityChange, false);
        }
    }
};
</script>

<style>
.van-toast {
    background-color: rgba(0, 0, 0, 0.8)!important;
    border-radius: 0.04rem!important;

}
.van-toast--html, .van-toast--text {
    padding: 0!important;
}
.van-toast__text {
    padding: 0.12rem 0.16rem!important;
}
</style>
